// Convert the markdown-flavored TOS string returned by TosProvider into an array
// of HTML block strings suitable for passing to jQuery's .html() / .append().
//
// Supported syntax:
//   # text     → <h2>text</h2>
//   ## text    → <h3>text</h3>
//   - text     → <ul><li>text</li>…</ul> (consecutive items grouped)
//   ---        → <hr>
//   **bold**   → <b>bold</b> (inline)
//   blank line → separates blocks; consecutive non-blank, non-prefixed lines
//                are joined into a single <p>.
export function formatTosAsHtmlBlocks(tos: string): string[] {
  const blocks: string[] = [];
  let paragraph: string[] = [];
  let listItems: string[] = [];

  const flushParagraph = (): void => {
    if (paragraph.length > 0) {
      blocks.push(`<p>${renderInline(paragraph.join(' '))}</p>`);
      paragraph = [];
    }
  };

  const flushList = (): void => {
    if (listItems.length > 0) {
      const items = listItems.map((item) => `<li>${renderInline(item)}</li>`).join('');
      blocks.push(`<ul>${items}</ul>`);
      listItems = [];
    }
  };

  for (const rawLine of tos.split('\n')) {
    const line = rawLine.trim();

    if (line === '') {
      flushParagraph();
      flushList();
      continue;
    }

    if (line === '---') {
      flushParagraph();
      flushList();
      blocks.push('<hr>');
      continue;
    }

    if (line.startsWith('## ')) {
      flushParagraph();
      flushList();
      blocks.push(`<h3>${renderInline(line.slice(3))}</h3>`);
      continue;
    }

    if (line.startsWith('# ')) {
      flushParagraph();
      flushList();
      blocks.push(`<h2>${renderInline(line.slice(2))}</h2>`);
      continue;
    }

    if (line.startsWith('- ')) {
      flushParagraph();
      listItems.push(line.slice(2));
      continue;
    }

    flushList();
    paragraph.push(line);
  }

  flushParagraph();
  flushList();
  return blocks;
}

function renderInline(text: string): string {
  return escapeHtml(text).replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
}

function escapeHtml(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
